import dayjs from 'dayjs';

export type MatchComment = {
  commentText: string;
  createdAt: string;
  createdByUserId: string;
  createdByUserName: string;
};

interface CommentThreadProps {
  comments: MatchComment[];
  currentBusinessName: string;
}

export function CommentThread({
  comments,
  currentBusinessName,
}: CommentThreadProps) {
  if (!comments || comments.length === 0) {
    return null;
  }

  const orderedComments = [...comments].sort(
    (a, b) => dayjs(a.createdAt).valueOf() - dayjs(b.createdAt).valueOf()
  );

  return (
    <div className='mb-4 flex max-h-72 flex-col gap-4 overflow-y-auto rounded-lg border border-gray-100 bg-gray-50 p-4'>
      {orderedComments.map((comment) => {
        const isOwnComment = comment.createdByUserName === currentBusinessName;
        return (
          <div
            key={`${comment.createdByUserId}-${comment.createdAt}-${comment.commentText}`}
            className={`flex items-start gap-2 ${
              isOwnComment ? 'flex-row-reverse' : 'flex-row'
            }`}
          >
            {!isOwnComment && (
              <div className='flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gray-200'>
                <span className='text-xs font-medium text-gray-600'>
                  {comment.createdByUserName.charAt(0)}
                </span>
              </div>
            )}
            <div
              className={`flex max-w-[78%] flex-col ${
                isOwnComment ? 'items-end' : 'items-start'
              }`}
            >
              <div
                className={`mb-1 flex items-center gap-2 ${
                  isOwnComment ? 'flex-row-reverse' : 'flex-row'
                }`}
              >
                <span className='text-sm font-medium text-gray-700'>
                  {comment.createdByUserName}
                </span>
                <span className='text-xs text-gray-400'>
                  {dayjs(comment.createdAt).format('DD MMM YYYY')}
                </span>
              </div>
              <p
                className={`whitespace-pre-wrap break-words px-4 py-2 text-sm ${
                  isOwnComment
                    ? 'rounded-xl rounded-br-sm bg-blue-600 text-white'
                    : 'rounded-xl rounded-bl-sm bg-gray-100 text-gray-800'
                }`}
              >
                {comment.commentText}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
